/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable @typescript-eslint/camelcase */
import {
  CircularProgress,
  Grid,
  makeStyles,
  Typography,
} from '@material-ui/core';
import ButtonComponent from 'components/ButtonComponent';
import GenericForm from 'components/GenericForm';
import { Form, Formik } from 'formik';
import i18n from 'i18n';
import { authLoginRequest } from 'modules/auth/actions';
import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import * as Yup from 'yup';
import { screenFields } from './screenFields';
import styles from './styles';

const PASSWORD_MAX_LENGTH = 40;

const schema = Yup.object().shape({
  email: Yup.string()
    .email(i18n.t('EMAIL_INVALID_KEY'))
    .required(i18n.t('REQUIRED_FIELD')),
  password: Yup.string()
    .max(PASSWORD_MAX_LENGTH, i18n.t('MAX_LENGTH_PASSWORD'))
    .required(i18n.t('REQUIRED_FIELD')),
  stayLogged: Yup.boolean().notRequired(),
});

interface Props {
  isLoading: boolean;
  authLoginRequest: (values: any) => void;
  config: any;
}

const initialValues = {
  email: '',
  password: '',
  recaptcha_token: '',
};

const FormExample: React.FC<Props> = ({
  isLoading,
  authLoginRequest,
  config,
}) => {
  const classes = makeStyles(styles)();

  const onSubmit = values => {
    // eslint-disable-next-line no-undef
    grecaptcha
      .execute(process.env.REACT_APP_RECAPTCHA_KEY!, {
        action: 'autosky_user_login',
      })
      .then(token => {
        authLoginRequest({ ...values, 'recaptcha_token': token });
      });
  };

  React.useEffect(() => {
    const script = document.createElement('script');

    script.src = 'https://www.recaptcha.net/recaptcha/api.js';
    script.async = true;
    script.defer = true;

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  React.useEffect(() => {
    const script = document.createElement('script');

    script.src = `https://www.recaptcha.net/recaptcha/api.js?render=${process
      .env.REACT_APP_RECAPTCHA_KEY!}`;
    script.async = true;
    script.defer = true;

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <Grid>
      <Grid item container xs={12} className={classes.spacingContainer}>
        <Grid item xs={12} className={classes.login}>
          <Typography variant="h3" className={classes.titleLogin}>
            {i18n.t('LOGIN_KEY')}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="body1" className={classes.subtitleLogin}>
            {i18n.t('ENTER_DESCRIPTION_KEY')}
          </Typography>
        </Grid>
      </Grid>
      <Formik
        initialValues={initialValues}
        enableReinitialize
        validateOnChange={false}
        validationSchema={schema}
        onSubmit={onSubmit}
      >
        {({ setFieldValue, errors, values, submitForm }) => {
          return (
            <Form>
              <Grid container spacing={2}>
                <GenericForm
                  screenFields={screenFields}
                  values={values}
                  setFieldValue={setFieldValue}
                  errors={errors}
                />
                {config?.activeDirectoryType !== 'externo' && (
                  <Grid container justifyContent="space-between" item xs={12}>
                    <Grid
                      item
                      className={classes.changePasswordContainer}
                      xs={6}
                    >
                      <Typography
                        variant="button"
                        component={Link}
                        to="/changePassword"
                        style={{
                          textShadow: '0px -1px 1px rgba(0, 0, 0, 0.2)',
                          color: config?.backgroundColor
                            ? config?.backgroundColor
                            : '#0064af',
                        }}
                      >
                        {i18n.t('CHANGE_PASSWORD_KEY')}
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      className={classes.forgotPasswordLinkContainer}
                      xs={6}
                    >
                      <Typography
                        variant="button"
                        component={Link}
                        to="/forgotPassword"
                        style={{
                          textShadow: '0px -1px 1px rgba(0, 0, 0, 0.2)',
                          color: config?.backgroundColor
                            ? config?.backgroundColor
                            : '#0064af',
                        }}
                      >
                        {i18n.t('FORGOT_PASSWORD_KEY')}
                      </Typography>
                    </Grid>
                  </Grid>
                )}

                <div
                  className="g-recaptcha"
                  data-sitekey={process.env.REACT_APP_RECAPTCHA_KEY!}
                  data-callback="onSubmit"
                  data-size="invisible"
                  data-badge="bottomright"
                ></div>

                <Grid item xs={12}>
                  <ButtonComponent
                    onClick={submitForm}
                    color="secondary"
                    variant="contained"
                    disabled={isLoading}
                    type="submit"
                    removeUpperCase
                    style={{
                      textShadow: '0px -1px 1px rgba(0, 0, 0, 0.2)',
                      color: 'white',
                      background: config?.backgroundColor
                        ? config?.backgroundColor
                        : '#0064af',
                    }}
                  >
                    {isLoading ? (
                      <CircularProgress size={15} />
                    ) : (
                      i18n.t('ENTER_KEY')
                    )}
                  </ButtonComponent>
                </Grid>
              </Grid>
            </Form>
          );
        }}
      </Formik>
    </Grid>
  );
};

const mapStateToProps = ({ auth, config }) => ({
  fields: auth.fields,
  isLoading: auth.isLoading,
  config,
});

export default connect(mapStateToProps, { authLoginRequest })(FormExample);
